import { render } from "./IconPaper.vue?vue&type=template&id=1856198a"
import script from "./IconPaper.vue?vue&type=script&lang=ts"
export * from "./IconPaper.vue?vue&type=script&lang=ts"
script.render = render

export default script